import { useRef, useEffect } from 'react';
import { useI18n } from '../i18n/I18nContext';
import gsap from 'gsap';

export function LanguageSwitcher() {
  const { locale, setLocale, t } = useI18n();
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    gsap.fromTo(
      buttonRef.current,
      { opacity: 0, y: -20, scale: 0.9 },
      { opacity: 1, y: 0, scale: 1, duration: 0.6, ease: 'power3.out', delay: 0.5 },
    );
  }, []);

  return (
    <button
      ref={buttonRef}
      onClick={() => setLocale(locale === 'en' ? 'es' : 'en')}
      className="lang-switcher"
      style={{
        position: 'fixed',
        top: '2rem',
        right: '2rem',
        zIndex: 1000,
        padding: '0.75rem 1.25rem',
        background: 'var(--card-bg)',
        border: '1px solid var(--border-color)',
        borderRadius: '100px',
        color: 'var(--fg-primary)',
        fontSize: '0.875rem',
        fontWeight: 600,
        fontFamily: "'JetBrains Mono', monospace",
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        transition: 'all 0.3s ease',
        backdropFilter: 'blur(20px)',
      }}
      onMouseEnter={e => gsap.to(e.currentTarget, { borderColor: 'var(--accent-primary)', boxShadow: '0 10px 30px rgba(0, 255, 136, 0.1)', scale: 1.05, duration: 0.2 })}
      onMouseLeave={e => gsap.to(e.currentTarget, { borderColor: 'var(--border-color)', boxShadow: 'none', scale: 1, duration: 0.2 })}
      aria-label={`Switch to ${locale === 'en' ? 'Spanish' : 'English'}`}
    >
      <span style={{
        fontSize: '1.25rem',
      }}>
        {locale === 'en' ? '🇺🇸' : '🇪🇸'}
      </span>
      <span>{t('lang.current')}</span>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginLeft: '0.25rem' }}>
        <path d="M21 12H3M12 3v18" />
      </svg>
    </button>
  );
}